import VehicleSelectionHtml from './vehicle.selection.html';

export function VehicleSelectionDirective () {
  return {
    restrict: 'E',
    templateUrl: VehicleSelectionHtml,
    controller: 'VehicleSelectionCtrl',
    scope: {
      customer: '=',
      entity: '=',
      onSelect: '&',
      parent: '@',
      unselectable: '=',
      vehicle: '='
    }
  }
}